import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { stringify } from 'hub-http/helpers/params';
import { useCallback } from 'react';
import { useHistory } from 'quartz-routing/react-router';
import { BUNDLE } from '../../constants/routes';
import { getPublicPagePath } from '../../utils/getPublicPagePath';
import { jsx as _jsx } from "react/jsx-runtime";
function buildBundleRouterPath(defaultProductApiName) {
  const queryString = stringify({
    products: [`${defaultProductApiName}_1`]
  });
  return `/${BUNDLE}?${queryString}`;
}
export const PublicCalculatorAnchorLink = ({
  defaultProductApiName,
  onClick
}) => {
  const history = useHistory();
  const routerPath = buildBundleRouterPath(defaultProductApiName);
  const href = `${getPublicPagePath()}${routerPath}`;
  const handleClick = useCallback(e => {
    e.preventDefault();
    onClick === null || onClick === void 0 || onClick();
    history.push(routerPath);
  }, [onClick, history, routerPath]);
  return /*#__PURE__*/_jsx(Link, {
    marginInlineStart: "200",
    href: href,
    onClick: handleClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "publicPricingPage.header.calculateYourPrice"
    })
  });
};